import React from 'react';
import universal from 'react-universal-component';

import { Skeleton } from 'app/modules/Betting';

const PAGE = 'Live';

export default universal(() => import(/* webpackChunkName: '[request]' */ `./${PAGE}`), {
  chunkName: PAGE,
  resolve: require.resolveWeak(`./${PAGE}`),
  loading: () => (
    <Skeleton />
  ),
});
